
import { Component, Vue } from "vue-property-decorator";
import Login from "@/views/Login.vue";
import Layout from "@/views/Layout.vue";

@Component({
	components: {
		Login,
		Layout,
	},
})
export default class Main extends Vue {

	get isLoaded() {
		return this.$store.state.loaded;
	}

	get loginState() {
		return this.$store.state.authState;
	}

}
